export const segments = [
    {
        id: 'none',
        label: 'Select segment',
        score: 0,
        median: {
            must: 0,
            does: 0,
            commitment: 0
        },
        nps: {
            must: 0,
            does: 0,
            satisfied: 0
        }
    },
    {
        id: 'aerospace',
        label: 'Aerospace',
        score: 3.87,
        median: {
            must: 9,
            does: 7,
            commitment: 7.5
        },
        nps: {
            must: 0.88,
            does: 26,
            satisfied: 46
        }
    },
    {
        id: 'airline',
        label: 'Airline',
        score: 3.23,
        median: {
            must: 9,
            does: 7,
            commitment: 7
        },
        nps: {
            must: 0.77,
            does: 32,
            satisfied: 32
        }
    },
    {
        id: 'automobile',
        label: 'Automobile',
        score: 3.19,
        median: {
            must: 9,
            does: 7,
            commitment: 8
        },
        nps: {
            must: 0.75,
            does: 17,
            satisfied: 50
        }
    },
    {
        id: 'banking',
        label: 'Banking',
        score: 3.61,
        median: {
            must: 8,
            does: 7,
            commitment: 7
        },
        nps: {
            must: 0.67,
            does: 32,
            satisfied: 21
        }
    },
    {
        id: 'creditUnion',
        label: 'Credit Union',
        score: 2.84,
        median: {
            must: 8,
            does: 9,
            commitment: 8
        },
        nps: {
            must: 0.68,
            does: 63,
            satisfied: 37
        }
    },
    {
        id: 'consumerBrands',
        label: 'Consumer Brands',
        score: 3.60,
        median: {
            must: 9,
            does: 7,
            commitment: 7
        },
        nps: {
            must: 0.86,
            does: 14,
            satisfied: 14
        }
    },
    {
        id: 'consumerPackagedGoods',
        label: 'Consumer Packaged Goods',
        score: 3.43,
        median: {
            must: 9,
            does: 7,
            commitment: 7.5
        },
        nps: {
            must: 0.87,
            does: 29,
            satisfied: 28
        }
    },
    {
        id: 'insuranceAndDiversigiedFinancialServices',
        label: 'Insurance & Diversified Financial Services',
        score: 2.83,
        median: {
            must: 9,
            does: 8,
            commitment: 8
        },
        nps: {
            must: 0.79,
            does: 13,
            satisfied: 26
        }
    },
    {
        id: 'healthcareProvider',
        label: 'Healthcare Provider',
        score: 2.25,
        median: {
            must: 9,
            does: 6,
            commitment: 7
        },
        nps: {
            must: 0.82,
            does: -30,
            satisfied: 0
        }
    },
    {
        id: 'healthcareInsurer',
        label: 'Health Care Insurer',
        score: 2.96,
        median: {
            must: 9,
            does: 7,
            commitment: 8
        },
        nps: {
            must: 0.86,
            does: 5,
            satisfied: 38
        }
    },
    {
        id: 'insurance',
        label: 'Insurance',
        score: 2.89,
        median: {
            must: 9,
            does: 8,
            commitment: 8
        },
        nps: {
            must: 0.79,
            does: 13,
            satisfied: 26
        }
    },
    {
        id: 'manufacturingDiversified',
        label: 'Manufacturing - Diversified',
        score: 3.69,
        median: {
            must: 9,
            does: 7,
            commitment: 7
        },
        nps: {
            must: 0.88,
            does: 39,
            satisfied: 42
        }
    },
    {
        id: 'manufacturingIndustrialGoods',
        label: 'Manufacturing - Industrial Goods',
        score: 2.55,
        median: {
            must: 8,
            does: 6,
            commitment: 7
        },
        nps: {
            must: 0.77,
            does: -12,
            satisfied: 0
        }
    },
    {
        id: 'manufacturingProcessOriented',
        label: 'Manufacturing - Process Oriented',
        score: 2.86,
        median: {
            must: 9,
            does: 6,
            commitment: 7
        },
        nps: {
            must: 0.70,
            does: -17,
            satisfied: -4
        }
    },
    {
        id: 'manufacturingVehiclesAndEquipment',
        label: 'Manufacturing - Vehicles & Equipment',
        score: 2.63,
        median: {
            must: 9,
            does: 7.5,
            commitment: 7.5
        },
        nps: {
            must: 0.88,
            does: 39,
            satisfied: 42
        }
    },
    {
        id: 'mediaAndEntertainment',
        label: 'Media & Entertainment',
        score: 3.72,
        median: {
            must: 9,
            does: 7,
            commitment: 7
        },
        nps: {
            must: 0.83,
            does: 20,
            satisfied: 27
        }
    },
    {
        id: 'pharmaceuticalsAndMedicalDevices',
        label: 'Pharmaceuticals & Medical Devices',
        score: 3.56,
        median: {
            must: 9,
            does: 8,
            commitment: 8
        },
        nps: {
            must: 0.90,
            does: 34,
            satisfied: 45
        }
    },
    {
        id: 'retailGeneral',
        label: 'Retail - General',
        score: 3.58,
        median: {
            must: 9,
            does: 7,
            commitment: 7
        },
        nps: {
            must: 0.79,
            does: 19,
            satisfied: 23
        }
    },
    {
        id: 'retailGroceries',
        label: 'Retail - Groceries',
        score: 3.29,
        median: {
            must: 8,
            does: 7,
            commitment: 7
        },
        nps: {
            must: 0.61,
            does: 7,
            satisfied: 25
        }
    },
    {
        id: 'retailOnline',
        label: 'Retail - Online',
        score: 4.50,
        median: {
            must: 9,
            does: 8,
            commitment: 8
        },
        nps: {
            must: 0.81,
            does: 43,
            satisfied: 52
        }
    },
    {
        id: 'retailSpeciality',
        label: 'Retail - Specialty',
        score: 2.88,
        median: {
            must: 8,
            does: 6,
            commitment: 6
        },
        nps: {
            must: 0.61,
            does: 0,
            satisfied: -4
        }
    },
    {
        id: 'softwareAndTechnology',
        label: 'Software & Technology',
        score: 3.66,
        median: {
            must: 8.5,
            does: 8.5,
            commitment: 8
        },
        nps: {
            must: 0.75,
            does: 40,
            satisfied: 35
        }
    },
    {
        id: 'transportation',
        label: 'Transportation',
        score: 3.21,
        median: {
            must: 8,
            does: 7.5,
            commitment: 7.5
        },
        nps: {
            must: 0.77,
            does: 33,
            satisfied: 47
        }
    },
    {
        id: 'telecommunications',
        label: 'Telecommunications',
        score: 3.04,
        median: {
            must: 9,
            does: 7,
            commitment: 7
        },
        nps: {
            must: 0.75,
            does: -2,
            satisfied: 4
        }
    },
    {
        id: 'utilities',
        label: 'Utilities',
        score: 3.02,
        median: {
            must: 9,
            does: 7,
            commitment: 8
        },
        nps: {
            must: 0.73,
            does: 1,
            satisfied: 11
        }
    },
    {
        id: 'wealthManagement',
        label: 'Wealth Management',
        score: 3.77,
        median: {
            must: 9,
            does: 8,
            commitment: 8
        },
        nps: {
            must: 0.72,
            does: 40,
            satisfied: 44
        }
    },
    {
        id: 'otherAll',
        label: 'Other / All',
        score: 2.19,
        median: {
            must: 9,
            does: 6,
            commitment: 6.5
        },
        nps: {
            must: 0.80,
            does: -30,
            satisfied: -3
        }
    }
];

export const digitalNative = {
    score: 4.56,
    must: 9,
    does: 8,
    commitment: 8
};

export const topScore = 5.99;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/profile/formData/industrySegments.ts